/**
 * Farm status metadata helper
 * 
 * Simplified status model (v1):
 * - draft: Not visible to customers
 * - public: Visible to customers
 */

export type FarmStatus = 'draft' | 'public';

export interface FarmStatusMeta {
  label: string;
  description: string;
  variant: 'default' | 'secondary' | 'destructive' | 'outline';
  color: 'yellow' | 'green' | 'gray';
}

export function getFarmStatusMeta(status: FarmStatus | string | null | undefined): FarmStatusMeta {
  switch (status) {
    case 'public':
      return {
        label: 'Synlig för kunder',
        description: 'Din gård är nu synlig för kunder på Farmly.',
        variant: 'default',
        color: 'green',
      };
    case 'draft':
    default:
      return {
        label: 'Ej synlig (utkast)',
        description: 'Den här gården är ännu inte synlig för kunder.',
        variant: 'secondary',
        color: 'yellow',
      };
  }
}
